/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import './calendar.css';
import './calendar_theme_alfa-on-white.css';
import './calendar_theme_alfa-on-color.css';
import './calendar_theme_alfa-dark.css';
import './calendar_theme_alfa-light.css';

export * from './calendar';
export { default } from './calendar';
